import {
	AppPage,
	MimaDateFilter,
	MimaFilter,
	MimaText,
} from '../../components';
import styles from '../../assets/styles/AppHome/AppHome.module.scss';
import BusinessInsightCard from './BusinessInsightCard';
import ProgressBar from '@ramonak/react-progress-bar';
import { IoIosCheckmarkCircle } from 'react-icons/io';
import BusinessChartCard from './BusinessChartCard';
import QuickLinksCard from './QuickLinksCard';
import { MdCancel } from 'react-icons/md';
import { userStore } from '../../stores';
import React, { useState } from 'react';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import { AnimatePresence, motion } from 'framer-motion';
import {MdKeyboardArrowDown} from "react-icons/md";
import { useEffect } from 'react';

const AppHome = ({
	tradingName,
	transactionsSummary,
	expensePercentage,
	expenseAnalysis,
	loading,
	onSubmit,
	validationSchema,
	filterPeriod,
	resetFilter,
	toDoListTotal,
	isActivated,
	hasPin,
	isOnboarded,
	hasWithdrawal,
	goToOnboarding,
	goToSettings,
}) => {
	const [onReset, setOnReset] = useState(false);
	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);
	const [curr, setCurr2] = useState(transactionsSummary[0]?.currencyCode)
	const [hasExpense, setHasExpense] = useState(false)
	
	

	useEffect(()=>{
		const checkExpense = () => {
			expenseAnalysis.forEach(element => {
				if (element.value.length > 0) {
					setHasExpense(true);
				} 
			}); 
		}

		checkExpense();
	}, [])
	
	return (
		<AppPage tradingName={tradingName}>
			<MimaText variant="subtitle" mb={2} align="center">
				You are viewing {filterPeriod} Insights
			</MimaText>

			<Formik
				initialValues={{
					startDate: '',
					endDate: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<MimaFilter
						filterClick={() => {
							setOnReset(false);
							handleSubmit();
						}}
						loading={loading}
						resetClick={() => {
							setOnReset(true);
							resetFilter();
						}}>
						<div className="filter_content">
							<MimaDateFilter
								labelTitle="start date"
								name="startDate"
								value={!onReset ? values.startDate : ''}
								onChange={text => {
									setOnReset(false);
									setFieldValue('startDate', text);
								}}
								onBlur={handleBlur}
								width={18}
								touched={touched.startDate}
								error={errors.startDate}
							/>
							<MimaDateFilter
								labelTitle="End date"
								name="endDate"
								value={!onReset ? values.endDate : ''}
								onChange={text => {
									setOnReset(false);
									setFieldValue('endDate', text);
								}}
								onBlur={handleBlur}
								width={18}
								touched={touched.endDate}
								error={errors.endDate}
							/>
						</div>
					</MimaFilter>
				)}
			</Formik>

			<div className={styles.main}>
				{permissions.has('CAN VIEW BUSINESS TRANSACTIONS SUMMARY') && (
					<BusinessInsightCard transactionsSummary={transactionsSummary} setCurr2={setCurr2} filterPeriod={filterPeriod}/>
				)}
				<QuickLinksCard />
				{toDoListTotal < 100 ? (
					<div className={styles.toDo}>
						<MimaText variant="smallBold" mb={1}>
							You are almost done!
						</MimaText>
						<div className={styles.toDo__group}>
							<div className={styles.toDo__items}>
								<p>Activate Account</p>
								<span className={isActivated ? styles.toDo__green : ''}>
									{isActivated ? <IoIosCheckmarkCircle /> : <MdCancel />}
								</span>
							</div>
							{/* <div
								className={
									isOnboarded ? styles.toDo__items : styles.toDo__items_hover
								}
								onClick={goToOnboarding}>
								<p> Verification </p>
								<span className={isOnboarded ? styles.toDo__green : ''}>
									{isOnboarded ? <IoIosCheckmarkCircle /> : <MdCancel />}
								</span>
							</div> */}
							<div
								className={
									hasPin ? styles.toDo__items : styles.toDo__items_hover
								}
								onClick={!hasPin ? goToSettings : ()=>{}}>
								<p> Set Transaction Pin</p>
								<span className={hasPin ? styles.toDo__green : ''}>
									{hasPin ? <IoIosCheckmarkCircle /> : <MdCancel />}
								</span>
							</div>
							<div
								className={
									hasWithdrawal ? styles.toDo__items : styles.toDo__items_hover
								}
								onClick={!hasWithdrawal && goToSettings}>
								<p>Set Withdrawal Account</p>
								<span className={hasWithdrawal ? styles.toDo__green : ''}>
									{hasWithdrawal ? <IoIosCheckmarkCircle /> : <MdCancel />}
								</span>
							</div>
						</div>
						<ProgressBar
							completed={toDoListTotal}
							bgColor="var(--color-success)"
							animateOnRender
						/>
					</div>
				) : (
					''
				)}
				<div>
					
					
					{permissions.has('CAN VIEW BUSINESS TRANSACTIONS SUMMARY') &&
						(
							<>
								<div className={styles.expense}>
									<span>Expense Analysis</span> 
								</div>
		
								{expenseAnalysis.filter((x)=>{
										return x.currencyCode === curr
									}).map(analysis => (
										<BusinessChartCard
											expenseAnalysis={analysis.value}
											expensePercentage={expensePercentage}
											currencyCode={analysis.currencyCode}
										/>
									))}
									
							</>
						)}
				</div>

				{/* <ReminderCard /> */}
			</div>
		</AppPage>
	);
};

export default AppHome;
